import { createGlobalStyle } from 'styled-components';
import { px2vw } from '@utils/px2vw';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'Graphik-Regular', sans-serif;
    margin: 0;
    padding: 0;
  }

  :root {
    font-size: ${px2vw(16)};
  }

  body {
    margin: 0;
    padding: 0;
    background: #f4f4f4;
    width: 100%;
    height: 100vh;
  }

  button {
    padding: 0;
    margin: 0;
  }
`;

export default GlobalStyles;
